import MessageCard from './MessageCard'
export default MessageCard
